import { HabitSchedule } from '@griply/types';

import { RRule } from './lib/rrule';

export const getScheduleInterval = (schedule: HabitSchedule) => {
  if (schedule.frequency) {
    return 1;
  }

  const rrule = RRule.fromString(schedule.rrule.format);
  return Math.max(1, rrule.origOptions.interval ?? 1);
};
